import React, { memo } from 'react';
import cc from 'classcat';
import { phonePrefix } from 'lib/constants';
import Fieldset from 'components/Fieldset';
import './phoneField.css';

interface PhoneFieldProps {
  field: object;
  name: string;
  labelText: string;
  className?: string;
  editable?: boolean;
  inline?: boolean;
  showOptional?: boolean;
  onChange: () => void;
  onFocus: () => void;
}

const PhoneField = ({
  field,
  name,
  labelText,
  className,
  editable,
  inline,
  showOptional,
  onChange,
  onFocus
}: PhoneFieldProps) => (
  <div className={cc(['phoneField phoneField--withPrefix', className])}>
    <span className="phoneField__prefix">{phonePrefix.UK}</span>
    <Fieldset
      // @ts-ignore -- fieldset is not typescript component. "field" is required prop, has no default.
      field={field}
      name={name}
      labelText={labelText}
      onChange={onChange}
      onFocus={onFocus}
      editable={editable}
      inline={inline}
      showOptional={showOptional}
      inputType="tel"
      autoComplete="tel-national"
      className="phoneField__fieldSet"
      maxLength={10}
    />
  </div>
);

export default memo(PhoneField);
